// extracted by mini-css-extract-plugin
export var article = "main-module--article--2eOYv";
export var wrap = "main-module--wrap--1uSYH";